var exports = {
  "cI": "bannerContainer__mnGdVR",
  "Hx": "Flash__8JZen3",
  "ui": "FlashFullWidth__iwtw-k",
  "AG": "multiOrgLayout__HXwVxX",
  "m4": "Octicon__TA7CNq",
  "_S": "orgListWrapper__lyqzek",
  "sL": "ForceWrap__DA1kDp",
  "gW": "ProtectedOrgs_FullList__fSN7Rg",
  "zf": "ProtectedOrgs_Shortened__QMlWkS",
  "m5": "ShieldLockIcon__-7OtkJ",
};

module.exports = exports;
